import { NavLink } from "react-router";

const TABS = [
  { to: "/home", label: "Home" },
  { to: "/practice", label: "Practice" },
  { to: "/tutor", label: "Tutor" },
  { to: "/profile", label: "Profile" },
];

/**
 * Tabs appear on screens 15–18 only.
 *
 * Never during a session, a mock or onboarding: a tab bar mid-question is an
 * invitation to lose the session, and screen 11 in particular is deliberately
 * a locked room.
 */
export function TabBar() {
  return (
    <nav
      aria-label="Main"
      className="sticky bottom-0 mt-auto flex border-t border-border bg-bg px-2 pb-[env(safe-area-inset-bottom)] pt-1.5"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `flex min-h-12 flex-1 flex-col items-center justify-center gap-0.5 rounded-[var(--radius-control)] py-1 text-[11px] ${
              isActive ? "font-semibold text-accent" : "text-text-muted"
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
